import { render, staticRenderFns } from "./FormItemTextArea.vue?vue&type=template&id=13d5714e"
import script from "./FormItemTextArea.vue?vue&type=script&lang=js"
export * from "./FormItemTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports